"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._convertDocument = exports._convertQuery = void 0;
var Config_1 = require("../Config");
function _convertQuery(query) {
    if (Config_1.get().jstoreVersion === 'v2') {
        try {
            var outStr = JSON.stringify(query).replace(/"id":"(.*?)"/g, '"_id": {"$oid": "$1"}');
            return JSON.parse(outStr);
        }
        catch (ex) {
            return query;
        }
    }
    return query;
}
exports._convertQuery = _convertQuery;
function _convertDocument(doc) {
    var _a;
    if (Config_1.get().jstoreVersion === 'v2' && doc._id) {
        doc.id = (_a = doc._id) === null || _a === void 0 ? void 0 : _a.$oid;
        delete doc._id;
    }
    return doc;
}
exports._convertDocument = _convertDocument;
